import * as yup from "yup"

const message = "Campo Obrigatório";

export const transferServiceSchema = yup.object({
  serviceId: yup
    .string()
    .required( message ),
  queueId: yup
    .string()
    .required( message ),
  comment: yup
    .string()
    .default(""),
});

export type TransferServiceForm = yup.InferType<typeof transferServiceSchema>;
